/** @jsx jsx */

import { QueryLazyOptions } from '@apollo/react-hooks'
import { css, jsx } from '@emotion/core'
import { HFlow, Icon, Tag, Text, useTheme, VFlow } from 'bold-ui'
import { RegistrosDoseQueryVariables } from 'graphql/types.generated'
import React from 'react'
import { capitalize } from 'util/strConversor'
import { DoseItemModel, statusDoseRecord } from 'view/atendimentos/atendimento-vacinacao/model'

import { InfoCardModalVacinacao } from '../../vacinacao/VacinacaoCalendarioView'

export interface DoseItemProps {
  model: DoseItemModel
  handleOnDoseClicked: (info: InfoCardModalVacinacao) => void
  registrosDoseLazyQuery: (options?: QueryLazyOptions<RegistrosDoseQueryVariables>) => void
}

export function DoseItem(props: DoseItemProps) {
  const {
    nome,
    status,
    faixaEtaria,
    dataAprazamento,
    registradoAtendimento,
    doseId,
    imunobiologicoId,
    prontuarioId,
    nomeCompletoImuno,
    siglaImuno,
  } = props.model
  const theme = useTheme()
  const record = statusDoseRecord[status]

  const onDoseClicked = () => {
    props.registrosDoseLazyQuery({
      variables: {
        input: {
          doseId: doseId,
          imunobiologicoId: imunobiologicoId,
          prontuarioId: prontuarioId,
        },
      },
    })

    props.handleOnDoseClicked({
      imunobiologicoId: imunobiologicoId,
      doseId: doseId,
      doseNome: nome,
      faixaEtaria: faixaEtaria,
      imunobiologicoNome: nomeCompletoImuno,
      imunobiologicoSigla: siglaImuno,
    })
  }

  const style = css`
    border: 1px solid ${record.borderColor};
    background: ${record.backgroundColor};
    box-sizing: border-box;
    box-shadow: ${theme.shadows.outer[10]};
    &:hover {
      box-shadow: ${theme.shadows.outer[40]};
      cursor: pointer;
    }
    border-radius: 2px;
    min-height: 4.25rem;
    width: 100%;
    padding: 0.375rem;
  `

  return (
    <React.Fragment>
      <div css={style} onClick={onDoseClicked}>
        <VFlow vSpacing={0}>
          <div style={{ padding: '0.125rem' }}>
            <HFlow
              hSpacing={0.5}
              alignItems='center'
              justifyContent='space-between'
              style={{ marginBottom: '0.625rem' }}
            >
              <HFlow alignItems='center' justifyContent='flex-start' hSpacing={0.3}>
                {record.icon && <Icon color={record.iconColor} icon={record.icon} />}
                <Text fontWeight='bold' style={{ color: record.fontColor }}>
                  {record.nome}
                </Text>
              </HFlow>
              {registradoAtendimento && <Icon icon='clockOutline' color={theme.pallete.primary.main} />}
            </HFlow>
            <HFlow hSpacing={0.25} alignItems='baseline' style={{ paddingLeft: '0.125rem' }}>
              <Text fontWeight='bold'>{capitalize(nome)}</Text>
              {faixaEtaria && <Text> | {capitalize(faixaEtaria)}</Text>}
            </HFlow>
          </div>
          {dataAprazamento && <Tag>APR: {dataAprazamento}</Tag>}
        </VFlow>
      </div>
    </React.Fragment>
  )
}
